/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppVexonRouteImport } from './routes/_app/vexon'
import { Route as AppStealthAiWriterRouteImport } from './routes/_app/stealth-ai-writer'
import { Route as AppSeoScannerRouteImport } from './routes/_app/seo-scanner'
import { Route as AppSecureLlmRouteImport } from './routes/_app/secure-llm'
import { Route as AppDocumentRedactorRouteImport } from './routes/_app/document-redactor'
import { Route as AppContentHumanizerRouteImport } from './routes/_app/content-humanizer'
import { Route as AppContentEnhancerRouteImport } from './routes/_app/content-enhancer'
import { Route as AppContactUsRouteImport } from './routes/_app/contact-us'
import { Route as AppApiAgentDocNewRouteImport } from './routes/_app/api-agent-doc-new'
import { Route as AppApiAgentDocRouteImport } from './routes/_app/api-agent-doc'
import { Route as AppProvenanceRouteImport } from './routes/_app/_provenance'
import { Route as AppVexonIndexRouteImport } from './routes/_app/vexon/index'
import { Route as AppStealthAiWriterIndexRouteImport } from './routes/_app/stealth-ai-writer/index'
import { Route as AppDocumentRedactorIndexRouteImport } from './routes/_app/document-redactor/index'
import { Route as AppVexonResultRouteImport } from './routes/_app/vexon/result'
import { Route as AppStealthAiWriterResultRouteImport } from './routes/_app/stealth-ai-writer/result'
import { Route as AppStealthAiWriterGenerateArticleRouteImport } from './routes/_app/stealth-ai-writer/generate-article'
import { Route as AppDocumentRedactorResultRouteImport } from './routes/_app/document-redactor/result'
import { Route as AppDocumentRedactorOptionsRouteImport } from './routes/_app/document-redactor/options'
import { Route as AppProvenanceWritingAnalysisRouteImport } from './routes/_app/_provenance/writing-analysis'
import { Route as AppProvenanceHumanizedTextDetectorRouteImport } from './routes/_app/_provenance/humanized-text-detector'
import { Route as AppProvenanceCopyrightDetectorRouteImport } from './routes/_app/_provenance/copyright-detector'
import { Route as AppProvenanceAiDetectorRouteImport } from './routes/_app/_provenance/ai-detector'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppVexonRoute = AppVexonRouteImport.update({
  id: '/vexon',
  path: '/vexon',
  getParentRoute: () => AppRoute,
} as any)
const AppStealthAiWriterRoute = AppStealthAiWriterRouteImport.update({
  id: '/stealth-ai-writer',
  path: '/stealth-ai-writer',
  getParentRoute: () => AppRoute,
} as any)
const AppSeoScannerRoute = AppSeoScannerRouteImport.update({
  id: '/seo-scanner',
  path: '/seo-scanner',
  getParentRoute: () => AppRoute,
} as any)
const AppSecureLlmRoute = AppSecureLlmRouteImport.update({
  id: '/secure-llm',
  path: '/secure-llm',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentRedactorRoute = AppDocumentRedactorRouteImport.update({
  id: '/document-redactor',
  path: '/document-redactor',
  getParentRoute: () => AppRoute,
} as any)
const AppContentHumanizerRoute = AppContentHumanizerRouteImport.update({
  id: '/content-humanizer',
  path: '/content-humanizer',
  getParentRoute: () => AppRoute,
} as any)
const AppContentEnhancerRoute = AppContentEnhancerRouteImport.update({
  id: '/content-enhancer',
  path: '/content-enhancer',
  getParentRoute: () => AppRoute,
} as any)
const AppContactUsRoute = AppContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => AppRoute,
} as any)
const AppApiAgentDocNewRoute = AppApiAgentDocNewRouteImport.update({
  id: '/api-agent-doc-new',
  path: '/api-agent-doc-new',
  getParentRoute: () => AppRoute,
} as any)
const AppApiAgentDocRoute = AppApiAgentDocRouteImport.update({
  id: '/api-agent-doc',
  path: '/api-agent-doc',
  getParentRoute: () => AppRoute,
} as any)
const AppProvenanceRoute = AppProvenanceRouteImport.update({
  id: '/_provenance',
  getParentRoute: () => AppRoute,
} as any)
const AppVexonIndexRoute = AppVexonIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppVexonRoute,
} as any)
const AppStealthAiWriterIndexRoute = AppStealthAiWriterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStealthAiWriterRoute,
} as any)
const AppDocumentRedactorIndexRoute =
  AppDocumentRedactorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDocumentRedactorRoute,
  } as any)
const AppVexonResultRoute = AppVexonResultRouteImport.update({
  id: '/result',
  path: '/result',
  getParentRoute: () => AppVexonRoute,
} as any)
const AppStealthAiWriterResultRoute =
  AppStealthAiWriterResultRouteImport.update({
    id: '/result',
    path: '/result',
    getParentRoute: () => AppStealthAiWriterRoute,
  } as any)
const AppStealthAiWriterGenerateArticleRoute =
  AppStealthAiWriterGenerateArticleRouteImport.update({
    id: '/generate-article',
    path: '/generate-article',
    getParentRoute: () => AppStealthAiWriterRoute,
  } as any)
const AppDocumentRedactorResultRoute =
  AppDocumentRedactorResultRouteImport.update({
    id: '/result',
    path: '/result',
    getParentRoute: () => AppDocumentRedactorRoute,
  } as any)
const AppDocumentRedactorOptionsRoute =
  AppDocumentRedactorOptionsRouteImport.update({
    id: '/options',
    path: '/options',
    getParentRoute: () => AppDocumentRedactorRoute,
  } as any)
const AppProvenanceWritingAnalysisRoute =
  AppProvenanceWritingAnalysisRouteImport.update({
    id: '/writing-analysis',
    path: '/writing-analysis',
    getParentRoute: () => AppProvenanceRoute,
  } as any)
const AppProvenanceHumanizedTextDetectorRoute =
  AppProvenanceHumanizedTextDetectorRouteImport.update({
    id: '/humanized-text-detector',
    path: '/humanized-text-detector',
    getParentRoute: () => AppProvenanceRoute,
  } as any)
const AppProvenanceCopyrightDetectorRoute =
  AppProvenanceCopyrightDetectorRouteImport.update({
    id: '/copyright-detector',
    path: '/copyright-detector',
    getParentRoute: () => AppProvenanceRoute,
  } as any)
const AppProvenanceAiDetectorRoute = AppProvenanceAiDetectorRouteImport.update({
  id: '/ai-detector',
  path: '/ai-detector',
  getParentRoute: () => AppProvenanceRoute,
} as any)

export interface FileRoutesByFullPath {
  '/api-agent-doc': typeof AppApiAgentDocRoute
  '/api-agent-doc-new': typeof AppApiAgentDocNewRoute
  '/contact-us': typeof AppContactUsRoute
  '/content-enhancer': typeof AppContentEnhancerRoute
  '/content-humanizer': typeof AppContentHumanizerRoute
  '/document-redactor': typeof AppDocumentRedactorRouteWithChildren
  '/secure-llm': typeof AppSecureLlmRoute
  '/seo-scanner': typeof AppSeoScannerRoute
  '/stealth-ai-writer': typeof AppStealthAiWriterRouteWithChildren
  '/vexon': typeof AppVexonRouteWithChildren
  '/': typeof AppIndexRoute
  '/ai-detector': typeof AppProvenanceAiDetectorRoute
  '/copyright-detector': typeof AppProvenanceCopyrightDetectorRoute
  '/humanized-text-detector': typeof AppProvenanceHumanizedTextDetectorRoute
  '/writing-analysis': typeof AppProvenanceWritingAnalysisRoute
  '/document-redactor/options': typeof AppDocumentRedactorOptionsRoute
  '/document-redactor/result': typeof AppDocumentRedactorResultRoute
  '/stealth-ai-writer/generate-article': typeof AppStealthAiWriterGenerateArticleRoute
  '/stealth-ai-writer/result': typeof AppStealthAiWriterResultRoute
  '/vexon/result': typeof AppVexonResultRoute
  '/document-redactor/': typeof AppDocumentRedactorIndexRoute
  '/stealth-ai-writer/': typeof AppStealthAiWriterIndexRoute
  '/vexon/': typeof AppVexonIndexRoute
}
export interface FileRoutesByTo {
  '/api-agent-doc': typeof AppApiAgentDocRoute
  '/api-agent-doc-new': typeof AppApiAgentDocNewRoute
  '/contact-us': typeof AppContactUsRoute
  '/content-enhancer': typeof AppContentEnhancerRoute
  '/content-humanizer': typeof AppContentHumanizerRoute
  '/secure-llm': typeof AppSecureLlmRoute
  '/seo-scanner': typeof AppSeoScannerRoute
  '/': typeof AppIndexRoute
  '/ai-detector': typeof AppProvenanceAiDetectorRoute
  '/copyright-detector': typeof AppProvenanceCopyrightDetectorRoute
  '/humanized-text-detector': typeof AppProvenanceHumanizedTextDetectorRoute
  '/writing-analysis': typeof AppProvenanceWritingAnalysisRoute
  '/document-redactor/options': typeof AppDocumentRedactorOptionsRoute
  '/document-redactor/result': typeof AppDocumentRedactorResultRoute
  '/stealth-ai-writer/generate-article': typeof AppStealthAiWriterGenerateArticleRoute
  '/stealth-ai-writer/result': typeof AppStealthAiWriterResultRoute
  '/vexon/result': typeof AppVexonResultRoute
  '/document-redactor': typeof AppDocumentRedactorIndexRoute
  '/stealth-ai-writer': typeof AppStealthAiWriterIndexRoute
  '/vexon': typeof AppVexonIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/_provenance': typeof AppProvenanceRouteWithChildren
  '/_app/api-agent-doc': typeof AppApiAgentDocRoute
  '/_app/api-agent-doc-new': typeof AppApiAgentDocNewRoute
  '/_app/contact-us': typeof AppContactUsRoute
  '/_app/content-enhancer': typeof AppContentEnhancerRoute
  '/_app/content-humanizer': typeof AppContentHumanizerRoute
  '/_app/document-redactor': typeof AppDocumentRedactorRouteWithChildren
  '/_app/secure-llm': typeof AppSecureLlmRoute
  '/_app/seo-scanner': typeof AppSeoScannerRoute
  '/_app/stealth-ai-writer': typeof AppStealthAiWriterRouteWithChildren
  '/_app/vexon': typeof AppVexonRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/_provenance/ai-detector': typeof AppProvenanceAiDetectorRoute
  '/_app/_provenance/copyright-detector': typeof AppProvenanceCopyrightDetectorRoute
  '/_app/_provenance/humanized-text-detector': typeof AppProvenanceHumanizedTextDetectorRoute
  '/_app/_provenance/writing-analysis': typeof AppProvenanceWritingAnalysisRoute
  '/_app/document-redactor/options': typeof AppDocumentRedactorOptionsRoute
  '/_app/document-redactor/result': typeof AppDocumentRedactorResultRoute
  '/_app/stealth-ai-writer/generate-article': typeof AppStealthAiWriterGenerateArticleRoute
  '/_app/stealth-ai-writer/result': typeof AppStealthAiWriterResultRoute
  '/_app/vexon/result': typeof AppVexonResultRoute
  '/_app/document-redactor/': typeof AppDocumentRedactorIndexRoute
  '/_app/stealth-ai-writer/': typeof AppStealthAiWriterIndexRoute
  '/_app/vexon/': typeof AppVexonIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/api-agent-doc'
    | '/api-agent-doc-new'
    | '/contact-us'
    | '/content-enhancer'
    | '/content-humanizer'
    | '/document-redactor'
    | '/secure-llm'
    | '/seo-scanner'
    | '/stealth-ai-writer'
    | '/vexon'
    | '/'
    | '/ai-detector'
    | '/copyright-detector'
    | '/humanized-text-detector'
    | '/writing-analysis'
    | '/document-redactor/options'
    | '/document-redactor/result'
    | '/stealth-ai-writer/generate-article'
    | '/stealth-ai-writer/result'
    | '/vexon/result'
    | '/document-redactor/'
    | '/stealth-ai-writer/'
    | '/vexon/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/api-agent-doc'
    | '/api-agent-doc-new'
    | '/contact-us'
    | '/content-enhancer'
    | '/content-humanizer'
    | '/secure-llm'
    | '/seo-scanner'
    | '/'
    | '/ai-detector'
    | '/copyright-detector'
    | '/humanized-text-detector'
    | '/writing-analysis'
    | '/document-redactor/options'
    | '/document-redactor/result'
    | '/stealth-ai-writer/generate-article'
    | '/stealth-ai-writer/result'
    | '/vexon/result'
    | '/document-redactor'
    | '/stealth-ai-writer'
    | '/vexon'
  id:
    | '__root__'
    | '/_app'
    | '/_app/_provenance'
    | '/_app/api-agent-doc'
    | '/_app/api-agent-doc-new'
    | '/_app/contact-us'
    | '/_app/content-enhancer'
    | '/_app/content-humanizer'
    | '/_app/document-redactor'
    | '/_app/secure-llm'
    | '/_app/seo-scanner'
    | '/_app/stealth-ai-writer'
    | '/_app/vexon'
    | '/_app/'
    | '/_app/_provenance/ai-detector'
    | '/_app/_provenance/copyright-detector'
    | '/_app/_provenance/humanized-text-detector'
    | '/_app/_provenance/writing-analysis'
    | '/_app/document-redactor/options'
    | '/_app/document-redactor/result'
    | '/_app/stealth-ai-writer/generate-article'
    | '/_app/stealth-ai-writer/result'
    | '/_app/vexon/result'
    | '/_app/document-redactor/'
    | '/_app/stealth-ai-writer/'
    | '/_app/vexon/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vexon': {
      id: '/_app/vexon'
      path: '/vexon'
      fullPath: '/vexon'
      preLoaderRoute: typeof AppVexonRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stealth-ai-writer': {
      id: '/_app/stealth-ai-writer'
      path: '/stealth-ai-writer'
      fullPath: '/stealth-ai-writer'
      preLoaderRoute: typeof AppStealthAiWriterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seo-scanner': {
      id: '/_app/seo-scanner'
      path: '/seo-scanner'
      fullPath: '/seo-scanner'
      preLoaderRoute: typeof AppSeoScannerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/secure-llm': {
      id: '/_app/secure-llm'
      path: '/secure-llm'
      fullPath: '/secure-llm'
      preLoaderRoute: typeof AppSecureLlmRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/document-redactor': {
      id: '/_app/document-redactor'
      path: '/document-redactor'
      fullPath: '/document-redactor'
      preLoaderRoute: typeof AppDocumentRedactorRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content-humanizer': {
      id: '/_app/content-humanizer'
      path: '/content-humanizer'
      fullPath: '/content-humanizer'
      preLoaderRoute: typeof AppContentHumanizerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content-enhancer': {
      id: '/_app/content-enhancer'
      path: '/content-enhancer'
      fullPath: '/content-enhancer'
      preLoaderRoute: typeof AppContentEnhancerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contact-us': {
      id: '/_app/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof AppContactUsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-agent-doc-new': {
      id: '/_app/api-agent-doc-new'
      path: '/api-agent-doc-new'
      fullPath: '/api-agent-doc-new'
      preLoaderRoute: typeof AppApiAgentDocNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-agent-doc': {
      id: '/_app/api-agent-doc'
      path: '/api-agent-doc'
      fullPath: '/api-agent-doc'
      preLoaderRoute: typeof AppApiAgentDocRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_provenance': {
      id: '/_app/_provenance'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppProvenanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vexon/': {
      id: '/_app/vexon/'
      path: '/'
      fullPath: '/vexon/'
      preLoaderRoute: typeof AppVexonIndexRouteImport
      parentRoute: typeof AppVexonRoute
    }
    '/_app/stealth-ai-writer/': {
      id: '/_app/stealth-ai-writer/'
      path: '/'
      fullPath: '/stealth-ai-writer/'
      preLoaderRoute: typeof AppStealthAiWriterIndexRouteImport
      parentRoute: typeof AppStealthAiWriterRoute
    }
    '/_app/document-redactor/': {
      id: '/_app/document-redactor/'
      path: '/'
      fullPath: '/document-redactor/'
      preLoaderRoute: typeof AppDocumentRedactorIndexRouteImport
      parentRoute: typeof AppDocumentRedactorRoute
    }
    '/_app/vexon/result': {
      id: '/_app/vexon/result'
      path: '/result'
      fullPath: '/vexon/result'
      preLoaderRoute: typeof AppVexonResultRouteImport
      parentRoute: typeof AppVexonRoute
    }
    '/_app/stealth-ai-writer/result': {
      id: '/_app/stealth-ai-writer/result'
      path: '/result'
      fullPath: '/stealth-ai-writer/result'
      preLoaderRoute: typeof AppStealthAiWriterResultRouteImport
      parentRoute: typeof AppStealthAiWriterRoute
    }
    '/_app/stealth-ai-writer/generate-article': {
      id: '/_app/stealth-ai-writer/generate-article'
      path: '/generate-article'
      fullPath: '/stealth-ai-writer/generate-article'
      preLoaderRoute: typeof AppStealthAiWriterGenerateArticleRouteImport
      parentRoute: typeof AppStealthAiWriterRoute
    }
    '/_app/document-redactor/result': {
      id: '/_app/document-redactor/result'
      path: '/result'
      fullPath: '/document-redactor/result'
      preLoaderRoute: typeof AppDocumentRedactorResultRouteImport
      parentRoute: typeof AppDocumentRedactorRoute
    }
    '/_app/document-redactor/options': {
      id: '/_app/document-redactor/options'
      path: '/options'
      fullPath: '/document-redactor/options'
      preLoaderRoute: typeof AppDocumentRedactorOptionsRouteImport
      parentRoute: typeof AppDocumentRedactorRoute
    }
    '/_app/_provenance/writing-analysis': {
      id: '/_app/_provenance/writing-analysis'
      path: '/writing-analysis'
      fullPath: '/writing-analysis'
      preLoaderRoute: typeof AppProvenanceWritingAnalysisRouteImport
      parentRoute: typeof AppProvenanceRoute
    }
    '/_app/_provenance/humanized-text-detector': {
      id: '/_app/_provenance/humanized-text-detector'
      path: '/humanized-text-detector'
      fullPath: '/humanized-text-detector'
      preLoaderRoute: typeof AppProvenanceHumanizedTextDetectorRouteImport
      parentRoute: typeof AppProvenanceRoute
    }
    '/_app/_provenance/copyright-detector': {
      id: '/_app/_provenance/copyright-detector'
      path: '/copyright-detector'
      fullPath: '/copyright-detector'
      preLoaderRoute: typeof AppProvenanceCopyrightDetectorRouteImport
      parentRoute: typeof AppProvenanceRoute
    }
    '/_app/_provenance/ai-detector': {
      id: '/_app/_provenance/ai-detector'
      path: '/ai-detector'
      fullPath: '/ai-detector'
      preLoaderRoute: typeof AppProvenanceAiDetectorRouteImport
      parentRoute: typeof AppProvenanceRoute
    }
  }
}

interface AppProvenanceRouteChildren {
  AppProvenanceAiDetectorRoute: typeof AppProvenanceAiDetectorRoute
  AppProvenanceCopyrightDetectorRoute: typeof AppProvenanceCopyrightDetectorRoute
  AppProvenanceHumanizedTextDetectorRoute: typeof AppProvenanceHumanizedTextDetectorRoute
  AppProvenanceWritingAnalysisRoute: typeof AppProvenanceWritingAnalysisRoute
}

const AppProvenanceRouteChildren: AppProvenanceRouteChildren = {
  AppProvenanceAiDetectorRoute: AppProvenanceAiDetectorRoute,
  AppProvenanceCopyrightDetectorRoute: AppProvenanceCopyrightDetectorRoute,
  AppProvenanceHumanizedTextDetectorRoute:
    AppProvenanceHumanizedTextDetectorRoute,
  AppProvenanceWritingAnalysisRoute: AppProvenanceWritingAnalysisRoute,
}

const AppProvenanceRouteWithChildren = AppProvenanceRoute._addFileChildren(
  AppProvenanceRouteChildren,
)

interface AppDocumentRedactorRouteChildren {
  AppDocumentRedactorOptionsRoute: typeof AppDocumentRedactorOptionsRoute
  AppDocumentRedactorResultRoute: typeof AppDocumentRedactorResultRoute
  AppDocumentRedactorIndexRoute: typeof AppDocumentRedactorIndexRoute
}

const AppDocumentRedactorRouteChildren: AppDocumentRedactorRouteChildren = {
  AppDocumentRedactorOptionsRoute: AppDocumentRedactorOptionsRoute,
  AppDocumentRedactorResultRoute: AppDocumentRedactorResultRoute,
  AppDocumentRedactorIndexRoute: AppDocumentRedactorIndexRoute,
}

const AppDocumentRedactorRouteWithChildren =
  AppDocumentRedactorRoute._addFileChildren(AppDocumentRedactorRouteChildren)

interface AppStealthAiWriterRouteChildren {
  AppStealthAiWriterGenerateArticleRoute: typeof AppStealthAiWriterGenerateArticleRoute
  AppStealthAiWriterResultRoute: typeof AppStealthAiWriterResultRoute
  AppStealthAiWriterIndexRoute: typeof AppStealthAiWriterIndexRoute
}

const AppStealthAiWriterRouteChildren: AppStealthAiWriterRouteChildren = {
  AppStealthAiWriterGenerateArticleRoute:
    AppStealthAiWriterGenerateArticleRoute,
  AppStealthAiWriterResultRoute: AppStealthAiWriterResultRoute,
  AppStealthAiWriterIndexRoute: AppStealthAiWriterIndexRoute,
}

const AppStealthAiWriterRouteWithChildren =
  AppStealthAiWriterRoute._addFileChildren(AppStealthAiWriterRouteChildren)

interface AppVexonRouteChildren {
  AppVexonResultRoute: typeof AppVexonResultRoute
  AppVexonIndexRoute: typeof AppVexonIndexRoute
}

const AppVexonRouteChildren: AppVexonRouteChildren = {
  AppVexonResultRoute: AppVexonResultRoute,
  AppVexonIndexRoute: AppVexonIndexRoute,
}

const AppVexonRouteWithChildren = AppVexonRoute._addFileChildren(
  AppVexonRouteChildren,
)

interface AppRouteChildren {
  AppProvenanceRoute: typeof AppProvenanceRouteWithChildren
  AppApiAgentDocRoute: typeof AppApiAgentDocRoute
  AppApiAgentDocNewRoute: typeof AppApiAgentDocNewRoute
  AppContactUsRoute: typeof AppContactUsRoute
  AppContentEnhancerRoute: typeof AppContentEnhancerRoute
  AppContentHumanizerRoute: typeof AppContentHumanizerRoute
  AppDocumentRedactorRoute: typeof AppDocumentRedactorRouteWithChildren
  AppSecureLlmRoute: typeof AppSecureLlmRoute
  AppSeoScannerRoute: typeof AppSeoScannerRoute
  AppStealthAiWriterRoute: typeof AppStealthAiWriterRouteWithChildren
  AppVexonRoute: typeof AppVexonRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppProvenanceRoute: AppProvenanceRouteWithChildren,
  AppApiAgentDocRoute: AppApiAgentDocRoute,
  AppApiAgentDocNewRoute: AppApiAgentDocNewRoute,
  AppContactUsRoute: AppContactUsRoute,
  AppContentEnhancerRoute: AppContentEnhancerRoute,
  AppContentHumanizerRoute: AppContentHumanizerRoute,
  AppDocumentRedactorRoute: AppDocumentRedactorRouteWithChildren,
  AppSecureLlmRoute: AppSecureLlmRoute,
  AppSeoScannerRoute: AppSeoScannerRoute,
  AppStealthAiWriterRoute: AppStealthAiWriterRouteWithChildren,
  AppVexonRoute: AppVexonRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
